import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyAKQtBC9Idw2t4gx4RZjw_DHMrj-owAExY",
    authDomain: "ad168-51697.firebaseapp.com",
    projectId: "ad168-51697",
    storageBucket: "ad168-51697.appspot.com",
    messagingSenderId: "904826533660",
    appId: "1:904826533660:web:d35c1425892da00c7b6cd9",
    measurementId: "G-71BVXTHN27"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

// Set persistent auth state
setPersistence(auth, browserLocalPersistence)
    .catch((error) => {
        console.error("Auth persistence error:", error);
    });
